import React from "react";
import { StoreCard } from "../../../lib/types/detailsTypes";
import { Box, Typography } from "@mui/material";

interface StampStripProps {
  card: StoreCard;
  onClick: () => void;
}

const StampCardStrip: React.FC<StampStripProps> = ({ card, onClick }) => {
  const filled = card.balance ?? 0;
  const total = card.maxBalance ?? 0;

  const isRewardAvailable =
    card.rewards?.some((r) => card.balance >= r.balanceRequired) ||
    filled >= total;

  return (
    <Box
      onClick={onClick}
      sx={{
        width: "100%",
        px: 2,
        py: 1,
        boxSizing: "border-box",
        borderBottom: "1px solid rgba(0,0,0,.08)",
        backgroundColor: card.stampAreaBackgroundColor || "#ffffff",
        "&:hover": { backgroundColor: "rgba(0,0,0,.03)", cursor: "pointer" },
        color: card.cardTextColor || "#000",
      }}
    >
      {/* ─ header row: name + count + reward dot ─ */}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="body1" fontWeight={500}>
          <strong>{card.cardName || "Stamp Card"}</strong>
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          {isRewardAvailable && (
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: "#ff9800",
                mr: 1,
              }}
            />
          )}
          <Typography variant="body2" fontWeight={500}>
            {filled}/{total} stamps
          </Typography>
        </Box>
      </Box>

      {/* ─ circle progress row ─ */}
      <Box sx={{ mt: 0.5, display: "flex", gap: 0.4 }}>
        {Array.from({ length: total }).map((_, i) => (
          <Box
            key={i}
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              flexShrink: 0,
              backgroundColor:
                i < filled
                  ? card.activeStampColor || "#4caf50"
                  : card.inactiveStampColor || "#e0e0e0",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default StampCardStrip;
